/*
	cart changes
	shortcode: cc
*/
(function() {
  var mod = {
    has: function(value) {
      return typeof value !== "undefined" && value !== null && value !== "";
    },
    classList: {
		  add: function(node, className) {
		    if (!node.classList.contains(className)) node.classList.add(className);
		  },
		  remove: function(node, className) {
		    if (node.classList.contains(className)) node.classList.remove(className);
		  }
		},
    count: async function(total) {
    	if (!mod.has(total)) total = true;
    	if (total === true) {
    		var span = document.querySelector("span.cart-count");
  			if (mod.has(span)) return parseInt(span.innerHTML);
    	} else {
	    	var pageKeyword = location.href.split("?").shift().split("/").pop().toLowerCase();
	    	var cartContainer = document.querySelector("#CartContainer");
	    	var cartForm = cartContainer.querySelector("#ajaxCartForm");
	    	if (!mod.has(cartForm)) {
	    		if (mod.has(window.ShopifyAPI)) {
	    			if (!mod.has(mod.firstQuantity) && mod.firstCart !== true) {
			    		var cart = await window.ShopifyAPI.getCart();
		  	  		if (mod.has(cart)) {
	    					mod.firstCart = true;
		  	  			for (var i=0; i<=cart.items.length-1; i++) {
		  	  				var item = cart.items[i];
		  	  				var keyword = item.url.split("?").shift().split("/").pop().toLowerCase();
		  	  				if (keyword === pageKeyword) {
		  	  					mod.firstQuantity = item.quantity;
		  	  				}
		  	  			}
		  	  		}
	    			}
	    			if (mod.has(mod.firstQuantity)) return mod.firstQuantity;
	    		}
	    	} else {
	    		var nodes = cartForm.querySelectorAll(".cart-products .cart__row");
	    		for (var i=0; i<=nodes.length-1; i++) {
	    			var node = nodes[i];
	    			var keyword = node.querySelector(".cart__product-name a").getAttribute("href").split("?").shift().split("/").pop().toLowerCase();
	    			if (keyword === pageKeyword) {
	    				var quantity = parseInt(node.querySelector("input[type=\"number\"]").value);
	    				return quantity;
	    			}
	    		}
	    	}
    	}
    	return 0;
    },
    events: function(evt) {
    	var link = document.querySelector("a.site-nav__link.cart-link");
    	var buttonView = document.querySelector(".cart-message-toast-wrapper .notification-toast #notificationToastPop button.nt-cart-view-btn");
    	var buttonAddItem = document.querySelector("#stickyAddToCart .button-wrapper-sticky_addtocart");
    	if (mod.has(link) && mod.has(buttonView) && mod.has(buttonAddItem) && mod.eventsAdded !== true) {
    		mod.eventsAdded = true;
    		buttonView.addEventListener("click", function() {
    			link.click();
    		});
            buttonView.classList.add("cc-hide-this");
    		buttonViewItem = buttonAddItem.cloneNode(true);
    		var div = document.createElement("div");
    		div.appendChild(buttonViewItem);
    		div.innerHTML = div.innerHTML.split("addtocart").join("viewcart").split("add-to-cart").join("view-cart").split("btn--sticky_viewcart").join("btn--sticky_addtocart");
    		buttonViewItem = div.querySelector(":scope > div");
    		var buttonView2 = buttonViewItem.querySelector("button");
    		buttonView2.removeAttribute("type");
    		buttonView2.querySelector("span.btn__view-cart-text").innerHTML = "View Cart";
    		buttonAddItem.parentElement.appendChild(buttonViewItem);
    		buttonView2.addEventListener("click", function(evt) {
    			evt.preventDefault();
    			link.click();
    		});
    	}
    },
    addToCartButtons: function() {
      var link = document.querySelector("a.site-nav__link.cart-link");
      if (link) {
        var buttons = document.querySelectorAll('button[type="submit"][name="add"], button[type="submit"].js-add-to-cart-button');
        for (var i=0; i<=buttons.length-1; i++) {
          var button = buttons[i];
          if (!button.hasAttribute("cc-button-set")) {
            button.setAttribute("cc-button-set", "1");
            button.addEventListener("click", function() {
              link.click();
            });
          }
        }
      }
    },
    check: async function() {
      if (mod.has(document.querySelector("body")) && document.querySelector("body").classList.contains("template-product")) {
      	if (await mod.count(true) > 0) {
      		mod.classList.add(document.querySelector("body"), "cc-has-items");
      		mod.events();
      	} else {
      		mod.classList.remove(document.querySelector("body"), "cc-has-items");
      	}
      	if (await mod.count(false) > 0) {
      		mod.classList.add(document.querySelector("body"), "cc-has-this-item");
      	} else {
      		mod.classList.remove(document.querySelector("body"), "cc-has-this-item");
      	}
        mod.addToCartButtons();
      }
      setTimeout(mod.check, 100);
    },
    start: function() {
      mod.check();
    }
  };
  mod.start();
})();